import {Component, Inject, OnInit} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {StatePersistenceService} from '../../service/state.persistence.service';
import {NavigationEnd, Router} from '@angular/router';
import {BreadcrumbService} from '../../service/breadcrumb.service';
import {filter} from 'rxjs/operators';
import {HttpResponseDto, InventoryControllerService, ProductDto} from '../../@api';
import {BrowserStorageService} from '../../service/browser.storage.service';
import {AbstractQuote} from '../../common/quote/abstract-quote';

const selector: string = 'inverters';

@Component({
    selector: selector,
    templateUrl: './inverters.component.html',
    styleUrls: ['./../retail.component.scss']
})
export class InvertersComponent extends AbstractQuote implements OnInit {

    activated: boolean;

    constructor(@Inject(DOCUMENT) public override document: Document,
                protected override state: StatePersistenceService,
                protected override browser: BrowserStorageService,
                protected override router: Router,
                protected override breadcrumbService: BreadcrumbService,
                private inventoryControllerService: InventoryControllerService) {
        super(document, state, browser, router, breadcrumbService);
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe((event: any): void => {
            const url: string = event.url;
            this.activated = (url.substring(url.lastIndexOf('/') + 1) === selector);
        });
    }

    override ngOnInit(): void {
        super.ngOnInit();
        this.inventoryControllerService.findAllProductsByCategory('Inverters').subscribe((response: HttpResponseDto): void => {
            let record: any = { products: [] };
            let inverters: ProductDto[] = JSON.parse(response.data);

            this.data = [];
            inverters.forEach((inverter: ProductDto): void => {
                if (record.products.length < 3) {
                    record.products.push(inverter);
                } else {
                    this.data.push(Object.assign({}, record));
                    record = { products: [] };
                    record.products.push(inverter);
                }
            });
            this.data.push(Object.assign({}, record));
        }, error => {
            console.log(error);
        });
    }
}
